/**
 * Manejo de envío de formulario PQRS con confirmación
 * @author carlos rodriguez
 * @since 2025
 */

// Inicializar sistema PQRS cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function () {
    const pqrsForm = document.getElementById('contact_form');
    
    if (pqrsForm) {
        // Prevenir envío por defecto y mostrar confirmación
        pqrsForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Confirmación usando sistema de alertas globales
            const result = await alertConfirm(
                '¿Confirmar envío?',
                '¿Estás seguro de enviar esta PQRS?'
            );
            
            if (result.isConfirmed) {
                await enviarFormularioPqrs(pqrsForm);
            }
        });
        
        console.log('✅ Sistema PQRS con SweetAlert inicializado');
    }
    
    // Limpiar archivos temporales cuando el usuario sale de la página
    let pqrEnviada = false;
    
    window.addEventListener('beforeunload', function(e) {
        // Solo limpiar si hay archivos y NO se ha enviado la PQRS
        const filepathEl = document.getElementById('filepath');
        const filepath = filepathEl?.value || '';
        
        if (filepath && !pqrEnviada) {
            // Usar sendBeacon con FormData para incluir CSRF token
            const formData = new FormData();
            formData.append('folder', filepath);
            formData.append('_token', document.querySelector('meta[name="csrf-token"]')?.content || '');
            
            navigator.sendBeacon('/pqrs/delete-tmp-folder', formData);
            console.log('🗑️ Limpieza de archivos temporales enviada');
        }
    });
    
    // Marcar cuando se envía exitosamente la PQRS
    window.marcarPqrEnviada = function() {
        pqrEnviada = true;
    };
});

/**
 * Envía el formulario PQRS por AJAX
 */
async function enviarFormularioPqrs(form) {
    const alpineComponent = Alpine.$data(document.querySelector('[x-data]'));
    if (alpineComponent) alpineComponent.isLoading = true;
    
    // Mostrar loading usando sistema de alertas globales
    showLoading('Enviando PQRS...', 'Por favor espera mientras procesamos tu solicitud');
    
    try {
        // Generar token reCAPTCHA antes de enviar
        let token = null;
        if (window.generarTokenRecaptcha) {
            try {
                token = await window.generarTokenRecaptcha();
            } catch (error) {
                console.error('Error generando token reCAPTCHA:', error);
                alpineComponent.isLoading = false;
                hideLoading();
                alertError('Error de seguridad', 'No se pudo verificar reCAPTCHA. Intenta de nuevo.');
                return;
            }
        }
        
        // Crear FormData y agregar token
        const formData = new FormData(form);
        if (token) {
            formData.set('g-recaptcha-response', token);
        }
        
        // Sincronizar valores de Alpine.js con FormData
        if (alpineComponent) {
            // Capturar valores de los selects gestionados por Alpine
            const tipoSelect = form.querySelector('select[name="tipo"]');
            const tramiteSelect = form.querySelector('select[name="tramite"]');
            
            if (tipoSelect && tipoSelect.value) {
                formData.set('tipo', tipoSelect.value);
            }
            if (tramiteSelect && tramiteSelect.value) {
                formData.set('tramite', tramiteSelect.value);
            }
        }
        
        // Debug: verificar valores que se están enviando
        console.log('FormData enviada:', {
            tipo: formData.get('tipo'),
            tramite: formData.get('tramite'),
            placa: formData.get('placa'),
            token: formData.get('g-recaptcha-response') ? 'presente' : 'ausente'
        });
        
        const response = await fetch(form.action, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok && data.success) {
            // Marcar que la PQRS se envió exitosamente (no limpiar en beforeunload)
            if (window.marcarPqrEnviada) window.marcarPqrEnviada();

            // Actualizar estado de Alpine.js para mostrar sección de éxito
            const alpineComponent = Alpine.$data(document.querySelector('[x-data]'));
            if (alpineComponent) {
                alpineComponent.pqrCreada = true;
                alpineComponent.pqrData = data.pqr;
                alpineComponent.isLoading = false;
            }

            // Mostrar SweetAlert de éxito
            Swal.fire({
              icon: 'success',
              title: 'PQRS registrada correctamente',
              html: `<b>ID:</b> #${String(data.pqr.id).padStart(6, '0')}<br>
                     <b>Tipo:</b> ${data.pqr.tipo}<br>
                     <b>Fecha:</b> ${data.pqr.fecha}<br>
                     <b>Estado:</b> ${data.pqr.estado}`,
              confirmButtonText: 'Aceptar'
            });

            // Cerrar loading
            hideLoading();

            // Limpiar Dropzone visual
            limpiarDropzones();

            // Scroll suave al inicio
            window.scrollTo({ top: 0, behavior: 'smooth' });

            // Nota: El servidor elimina automáticamente la carpeta temporal

        } else if (response.status === 422) {
            alpineComponent.isLoading = false;
            hideLoading();
            mostrarErroresValidacion(data.errors || {});
        } else {
            alpineComponent.isLoading = false;
            hideLoading();
            alertError('Error al enviar PQRS', data.message || 'Intenta nuevamente.');
        }
    } catch (error) {
        const alpineComponent = Alpine.$data(document.querySelector('[x-data]'));
        if (alpineComponent) alpineComponent.isLoading = false;
        
        hideLoading();
        console.error('Error al enviar PQRS:', error);
        alertError('Error de red', 'No se pudo enviar la PQRS. Intenta más tarde.');
    }
}

/**
 * Muestra errores de validación en el formulario
 * Usa el sistema de alertas globales (showValidationErrors)
 */
function mostrarErroresValidacion(errors) {
    const alpineComponent = Alpine.$data(document.querySelector('[x-data]'));
    
    if (alpineComponent) {
        // Actualizar errores reactivamente en Alpine
        alpineComponent.errores = errors;
        
        // Marcar todos los campos con error como "tocados" para que se muestren
        Object.keys(errors).forEach(campo => {
            if (alpineComponent.touched) {
                alpineComponent.touched[campo] = true;
            }
        });
        
        // Scroll al primer campo ANTES de mostrar alerta
        const primerCampo = Object.keys(errors)[0];
        scrollToField(primerCampo);
        
        // Usar función global de validación de alertas
        setTimeout(() => {
            showValidationErrors(errors);
        }, 300);
    }
}

/**
 * Hace scroll al campo con error
 */
function scrollToField(fieldName) {
    const field = document.querySelector(`[name="${fieldName}"]`) || 
                  document.getElementById(fieldName) ||
                  document.getElementById(`${fieldName}-select`);
    
    if (field) {
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}

/**
 * Limpia los dropzones del formulario
 */
function limpiarDropzones() {
    // Disparar evento personalizado para resetear todos los dropzones
    window.dispatchEvent(new Event('resetDropzones'));
    
    console.log('✨ Evento de limpieza de dropzones disparado');
}

